(function($) {
  $.fn.summary = function(options) {
    return this.each(function() {
      new $.Summary(this, options);
    });
  };

  $.Summary = function(e, o) {
    var element = $(e);
    var options = o || {};
    var maxHeight = options.maxHeight || 100;
    
    if(element.height <= maxHeight){ return; }
    
    var className = options.className || 'expand';
    var textHeight = e.offsetHeight;

    if (textHeight > maxHeight) {
      element.css({overflow: 'hidden'});
      element.height(maxHeight);

      var moreLink = $("<a>View More</a>").click(expand).addClass(className);
      var lessLink = $("<a>View Less</a>").click(collapse).addClass(className);
      element.after(moreLink);
      element.after(lessLink);
      lessLink.hide();
    }

    function expand() {
      element.animate({height: textHeight}, 'fast');
      moreLink.hide();
      lessLink.show();
    };

    function collapse() {
      element.animate({height: maxHeight}, 'fast');
      lessLink.hide();
      moreLink.show();
    };
  };


  //basic usage
  //$('.summary').summary();

  //overriding options
  $('.summary').summary({maxHeight: 400, className: 'view-more'});

})(jQuery);